function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter0_d_403_19)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "path-1-outside-1_403_19",
  maskUnits: "userSpaceOnUse",
  x: 0,
  y: 0.526321,
  width: 23,
  height: 28,
  fill: "black"
}, /*#__PURE__*/React.createElement("rect", {
  fill: "white",
  y: 0.526321,
  width: 23,
  height: 28
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M17.2105 1.52632L21.8421 6.1579V27H1V1.52633L17.2105 1.52632Z"
})), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M17.2105 1.52632L21.8421 6.1579V27H1V1.52633L17.2105 1.52632Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M21.8421 6.1579H22.8421V5.74369L22.5492 5.45079L21.8421 6.1579ZM17.2105 1.52632L17.9176 0.819215L17.6247 0.526321L17.2105 0.526321L17.2105 1.52632ZM21.8421 27V28H22.8421V27H21.8421ZM1 27H0V28H1V27ZM1 1.52633L1 0.526327L0 0.526327V1.52633H1ZM22.5492 5.45079L17.9176 0.819215L16.5034 2.23343L21.135 6.86501L22.5492 5.45079ZM20.8421 6.1579V27H22.8421V6.1579H20.8421ZM21.8421 26H1V28H21.8421V26ZM2 27V1.52633H0V27H2ZM1 2.52633L17.2105 2.52632L17.2105 0.526321L1 0.526327L1 2.52633Z",
  fill: "black",
  mask: "url(#path-1-outside-1_403_19)"
}));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M17 6.5V1L22.5 6.5H17Z",
  fill: "black"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M3.3158 9.63159H19.5263",
  stroke: "black"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M3.3158 14.2632H19.5263",
  stroke: "black"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M3.3158 23.5263H19.5263",
  stroke: "black"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M3.3158 18.8947H19.5263",
  stroke: "black"
});

var _ref8 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "filter0_d_403_19",
  x: 0,
  y: 0.526321,
  width: 25.8421,
  height: 29.4737,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dx: 2,
  dy: 1
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.5
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_403_19"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "effect1_dropShadow_403_19",
  result: "shape"
})));

function SvgDoc32(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 30,
    viewBox: "0 0 26 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoc32);
export default __webpack_public_path__ + "static/media/doc_32.f03f79a3.svg";
export { ForwardRef as ReactComponent };